import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { selectFavoriteVehicles } from "./selectFavoriteVehicles.js";
import { selectSlice } from "./selectSlice.js";
const selectFavoriteVehiclesTotalPages = createAppSelector(
  [selectSlice, selectFavoriteVehicles],
  ({ options }, vehicles) => {
    if (!vehicles.data) {
      return 0;
    }
    return Math.ceil(vehicles.data.total / options.limit);
  }
);
export {
  selectFavoriteVehiclesTotalPages
};
